import {ReactElement} from 'react';
import {Container} from '@chakra-ui/react';

import {py} from '@eksab/theme';

import {Header} from './header/Header';

export const getLayout = (page: ReactElement) => {
  return (
    <Container flexDir="column" py={py}>
      <Header flex="1" mb="8" />

      {page}
    </Container>
  );
};
